import { Component } from "@angular/core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-progress-container",
  templateUrl: "./progress-container.component.html",
  styleUrls: ["./progress-container.component.scss"],
  standalone: false,
})
export class ProgressContainerComponent {
  faSpinner = faSpinner;

  constructor() {}
}
